exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a[data-v-05b5e356]{color:#2d3f50}#logo .allied[data-v-05b5e356]{font-weight:500}#logo .crowds[data-v-05b5e356]{font-weight:400}#logo a[data-v-05b5e356]{color:#2d3f50!important;font-size:25px}#logo a[data-v-05b5e356]:active,#logo a[data-v-05b5e356]:focus,#logo a[data-v-05b5e356]:hover{text-decoration:none;color:#c1c1c1!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-05b5e356","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/elements/logo.vue
// module id = 81
// module chunks = 0